'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { buildGtmPageUrl, getGtmReferrerUrl } from '../utils/gtmNavigationHistory';

export function GTMErrorPage() {
  const pathname = usePathname();

  useEffect(() => {
    const t = setTimeout(() => {
      sendGTMEvent({
        event: 'error_page',
        error_url: buildGtmPageUrl(pathname),
        referrer: getGtmReferrerUrl()
      });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
